function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var Slip = require('../../../lib/saito/slip')["default"];
var _require = require('saito-js/lib/slip'),
  SlipType = _require.SlipType;
var _require2 = require('./scripting'),
  isNFTTuple = _require2.isNFTTuple,
  signAccessScriptWitness = _require2.signAccessScriptWitness;

/** Saito SlipType::P2SH (not yet exported from saito-js SlipType enum). */
var SLIP_TYPE_P2SH = 10;
function isP2shPublicKey(app) {
  var _app$crypto;
  var publicKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (!publicKey || !(app !== null && app !== void 0 && (_app$crypto = app.crypto) !== null && _app$crypto !== void 0 && _app$crypto.fromBase58)) {
    return false;
  }
  try {
    var hex = app.crypto.fromBase58(publicKey);
    return typeof hex === 'string' && hex.length >= 2 && hex.startsWith('00');
  } catch (err) {
    return false;
  }
}

/** Mirrors saito-core: Bound slips are never P2SH inputs for witness purposes. */
function isBoundSlip(slip) {
  return Number(slip === null || slip === void 0 ? void 0 : slip.type) === SlipType.Bound;
}

/** True when Rust would include this input in p2sh_idxs. */
function slipRequiresP2shWitness(app, slip) {
  if (isBoundSlip(slip)) {
    return false;
  }
  return isP2shPublicKey(app, (slip === null || slip === void 0 ? void 0 : slip.publicKey) || '');
}
function listRustP2shInputIndexes(app, tx) {
  var indexes = [];
  var from = (tx === null || tx === void 0 ? void 0 : tx.from) || [];
  for (var i = 0; i < from.length; i++) {
    if (slipRequiresP2shWitness(app, from[i])) {
      indexes.push(i);
    }
  }
  return indexes;
}
function attachP2shAccessScripts(_x, _x2) {
  return _attachP2shAccessScripts.apply(this, arguments);
}
function _attachP2shAccessScripts() {
  _attachP2shAccessScripts = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app, fulfillment_tx) {
    var _from$p2sh_indexes$;
    var _ref2,
      _ref2$payment_access_,
      payment_access_script,
      _ref2$listing_txs,
      listing_txs,
      from,
      p2sh_indexes,
      i,
      _from$i,
      witness_message,
      locking_scripts,
      _iterator,
      _step,
      listing_tx,
      listing_txmsg,
      access_scripts,
      _i,
      locking_script,
      _args = arguments,
      _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _ref2 = _args.length > 2 && _args[2] !== undefined ? _args[2] : {}, _ref2$payment_access_ = _ref2.payment_access_script, payment_access_script = _ref2$payment_access_ === void 0 ? '' : _ref2$payment_access_, _ref2$listing_txs = _ref2.listing_txs, listing_txs = _ref2$listing_txs === void 0 ? [] : _ref2$listing_txs;
          if (!(!app || !fulfillment_tx)) {
            _context.n = 1;
            break;
          }
          throw new Error('transaction and app are required for P2SH witness');
        case 1:
          from = fulfillment_tx.from || [];
          p2sh_indexes = [];
          for (i = 0; i < from.length; i++) {
            if (isP2shPublicKey(app, (_from$i = from[i]) === null || _from$i === void 0 ? void 0 : _from$i.publicKey)) {
              p2sh_indexes.push(i);
            }
          }
          if (p2sh_indexes.length) {
            _context.n = 2;
            break;
          }
          return _context.a(2, fulfillment_tx);
        case 2:
          witness_message = String(((_from$p2sh_indexes$ = from[p2sh_indexes[0]]) === null || _from$p2sh_indexes$ === void 0 ? void 0 : _from$p2sh_indexes$.utxoKey) || '');
          if (witness_message) {
            _context.n = 3;
            break;
          }
          throw new Error('P2SH input is missing utxoset key');
        case 3:
          locking_scripts = [];
          if (payment_access_script) {
            locking_scripts.push(payment_access_script);
          }
          _iterator = _createForOfIteratorHelper(listing_txs);
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              listing_tx = _step.value;
              listing_txmsg = listingTxmsg(listing_tx);
              locking_scripts.push(listing_txmsg.access_script || '');
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          if (!(locking_scripts.length !== p2sh_indexes.length)) {
            _context.n = 4;
            break;
          }
          throw new Error('P2SH input count does not match access script count');
        case 4:
          access_scripts = [];
          _i = 0;
        case 5:
          if (!(_i < p2sh_indexes.length)) {
            _context.n = 9;
            break;
          }
          locking_script = locking_scripts[_i] || '';
          if (locking_script) {
            _context.n = 6;
            break;
          }
          throw new Error('missing access script for P2SH input');
        case 6:
          _t = access_scripts;
          _context.n = 7;
          return signAccessScriptWitness(app, locking_script, witness_message);
        case 7:
          _t.push.call(_t, _context.v);
        case 8:
          _i++;
          _context.n = 5;
          break;
        case 9:
          fulfillment_tx.msg = fulfillment_tx.msg || {};
          fulfillment_tx.msg.access_scripts = access_scripts;
          return _context.a(2, fulfillment_tx);
      }
    }, _callee);
  }));
  return _attachP2shAccessScripts.apply(this, arguments);
}
function slipPublicKey(app, script_address) {
  if (!script_address) {
    return '';
  }
  if (script_address.length === 66 && script_address.startsWith('00')) {
    return app.crypto.toBase58(script_address);
  }
  return script_address;
}
function serializeSlip(slip) {
  if (!slip) {
    return '';
  }
  if (typeof slip.toJson === 'function') {
    return JSON.stringify(slip.toJson());
  }
  return JSON.stringify({
    publicKey: slip.publicKey,
    amount: slip.amount,
    type: slip.type,
    blockId: slip.blockId,
    txOrdinal: slip.txOrdinal,
    index: slip.index,
    utxoKey: slip.utxoKey
  });
}

/**
 * WASM Slip setters require bigint for blockId and txOrdinal.
 * JSON.parse and Number() paths may yield JS numbers — normalize before construction.
 */
function normalizeSlipJson(data) {
  if (!data || _typeof(data) !== 'object') {
    return data;
  }
  var normalized = _objectSpread({}, data);
  if (normalized.blockId != null && normalized.blockId !== '') {
    normalized.blockId = BigInt(normalized.blockId);
  }
  if (normalized.txOrdinal != null && normalized.txOrdinal !== '') {
    normalized.txOrdinal = BigInt(normalized.txOrdinal);
  }
  return normalized;
}
function findInventoryTriple(slips, p2sh_address) {
  if (!p2sh_address || !(slips !== null && slips !== void 0 && slips.length)) {
    return null;
  }
  for (var i = 0; i + 2 < slips.length; i++) {
    var _slips;
    if (!isNFTTuple(slips, i)) {
      continue;
    }
    // slip2.publicKey is the P2SH custody address, not a wallet public key.
    if (((_slips = slips[i + 1]) === null || _slips === void 0 ? void 0 : _slips.publicKey) === p2sh_address) {
      return [slips[i], slips[i + 1], slips[i + 2]];
    }
  }
  return null;
}
function parseStoredSlip(stored) {
  if (!stored) {
    return null;
  }
  try {
    var data = typeof stored === 'string' ? JSON.parse(stored) : stored;
    return new Slip(undefined, normalizeSlipJson(data));
  } catch (err) {
    return null;
  }
}
function listingTxmsg(transaction) {
  return (typeof (transaction === null || transaction === void 0 ? void 0 : transaction.returnMessage) === 'function' ? transaction.returnMessage() : transaction === null || transaction === void 0 ? void 0 : transaction.msg) || {};
}
function listingInputSlipJsonFromRecord(listing) {
  if (!listing) {
    return null;
  }
  var stored = [listing.utxo_slip1, listing.utxo_slip2, listing.utxo_slip3];
  if (stored.some(function (value) {
    return !value;
  })) {
    return null;
  }
  var json_triple = stored.map(function (value) {
    var data = typeof value === 'string' ? JSON.parse(value) : value;
    return normalizeSlipJson(data);
  });
  var slips = json_triple.map(function (data) {
    return new Slip(undefined, data);
  });
  if (slips.length !== 3 || !isNFTTuple(slips, 0)) {
    return null;
  }
  return json_triple;
}

/** Store bookkeeping only — index of tx within its confirming block. */
function transactionIndexInBlock() {
  var blk = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var tx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var signature = (tx === null || tx === void 0 ? void 0 : tx.signature) || '';
  var txs = (blk === null || blk === void 0 ? void 0 : blk.transactions) || [];
  for (var i = 0; i < txs.length; i++) {
    var _txs$i;
    if (((_txs$i = txs[i]) === null || _txs$i === void 0 ? void 0 : _txs$i.signature) === signature) {
      return i;
    }
  }
  return 0;
}
function returnListingSlipId() {
  var tx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var p2sh_address = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var outputs = (tx === null || tx === void 0 ? void 0 : tx.to) || [];
  for (var i = 0; i < outputs.length; i++) {
    var slip = outputs[i];
    if (p2sh_address && (slip === null || slip === void 0 ? void 0 : slip.publicKey) === p2sh_address) {
      var _ref, _slip$index;
      return Number((_ref = (_slip$index = slip === null || slip === void 0 ? void 0 : slip.index) !== null && _slip$index !== void 0 ? _slip$index : slip === null || slip === void 0 ? void 0 : slip.slip_id) !== null && _ref !== void 0 ? _ref : i) || 0;
    }
  }
  return 0;
}
function returnPaymentUtxoFromPurchase(tx) {
  var txmsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var app = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (!(tx !== null && tx !== void 0 && tx.signature) || !(txmsg !== null && txmsg !== void 0 && txmsg.p2sh_address) || !app) {
    return null;
  }
  var expected = slipPublicKey(app, txmsg.p2sh_address);
  if (!expected) {
    return null;
  }
  for (var i = 0; i < (tx.to || []).length; i++) {
    var _o$amount, _o$index;
    var o = tx.to[i];
    if ((o === null || o === void 0 ? void 0 : o.publicKey) !== expected) {
      continue;
    }
    var amount = typeof o.amount === 'bigint' ? o.amount : BigInt((_o$amount = o.amount) !== null && _o$amount !== void 0 ? _o$amount : 0);
    return {
      payment_tx_sig: tx.signature,
      payment_output_index: Number((_o$index = o === null || o === void 0 ? void 0 : o.index) !== null && _o$index !== void 0 ? _o$index : i),
      payment_amount: amount,
      p2sh_address: txmsg.p2sh_address,
      access_script: txmsg.access_script || ''
    };
  }
  return null;
}
function returnAmountPaidInPurchase(tx) {
  var txmsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var app = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var payment_utxo = returnPaymentUtxoFromPurchase(tx, txmsg, app);
  return payment_utxo ? payment_utxo.payment_amount : 0n;
}
function paymentInputFromOrder(order_row) {
  if (!order_row) {
    return null;
  }
  var stored = order_row.utxo_slip || order_row.payment_utxo_slip || '';
  return parseStoredSlip(stored);
}
module.exports = {
  SLIP_TYPE_P2SH: SLIP_TYPE_P2SH,
  isP2shPublicKey: isP2shPublicKey,
  isBoundSlip: isBoundSlip,
  slipRequiresP2shWitness: slipRequiresP2shWitness,
  listRustP2shInputIndexes: listRustP2shInputIndexes,
  slipPublicKey: slipPublicKey,
  attachP2shAccessScripts: attachP2shAccessScripts,
  serializeSlip: serializeSlip,
  normalizeSlipJson: normalizeSlipJson,
  findInventoryTriple: findInventoryTriple,
  parseStoredSlip: parseStoredSlip,
  listingTxmsg: listingTxmsg,
  listingInputSlipJsonFromRecord: listingInputSlipJsonFromRecord,
  transactionIndexInBlock: transactionIndexInBlock,
  returnListingSlipId: returnListingSlipId,
  returnAmountPaidInPurchase: returnAmountPaidInPurchase,
  returnPaymentUtxoFromPurchase: returnPaymentUtxoFromPurchase,
  paymentInputFromOrder: paymentInputFromOrder
};